import React from "react";
import Typical from "react-typical";
import "./Profile.css";
export default function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profilr-details">
          <div className="colz">
            <div className="colz-icon">
              <a
                href="https://www.facebook.com/people/Kokonod-Ray/pfbid02hgTK8UF7SAZCnod7Z4dTFWmLdb75xtuD7t7AjAp2RgoSRoDiC4NX7EzdZSZXLAXDl/"
                class="fa-brands fa-facebook"
                style={{ color: "blue" }}
              ></a>
              <a
                href="https://twitter.com/kokonod_ray?t=hA0RUAAGwCtMpKqatmlCuw&s=08"
                class="fa-brands fa-twitter"
                style={{ color: "lightblue" }}
              ></a>
              <a
                href="https://www.instagram.com/k_o_k_o_007/?hl=en"
                class="fa-brands fa-instagram"
                style={{ color: " #a4137e" }}
              ></a>
              <a
                href="https://www.linkedin.com/in/kokonod-ray-b161431a3/"
                class="fa-brands fa-linkedin "
                style={{ color: "#124191" }}
              ></a>
            </div>
          </div>
          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hello, I'M <span className="highlighted-text">Kokonod</span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1>
                {" "}
                <Typical
                  loop={Infinity}
                  steps={[
                    "FreeLancer 🔴",
                    3000,
                    "FullStak Developer 😎",
                    3000,
                    "Mern Stack Developer 👨🏽‍💻",
                    3000,
                    "Problem Solveing and DSA 💻",
                    3000,
                    "Backend Developer 🌐",
                    3000,
                  ]}
                />
              </h1>
              <span className="profile-role-tagline">
                Team worker and quick learner with a positive and hardworking
                attitude
              </span>
            </span>
          </div>
          <div className="profile-options">
            <a href="#ContactMe">
              <button className="btn primary-btn">
                {""}
                Hire Me{" "}
              </button>
            </a>

            <a href="RESUME.pdf" download="Kokonod Ray RESUME.pdf">
              <button className="btn highlighted-btn">Get Resume</button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
}
